<template>
    <div class="bg-gradient-loch">
      <a class="skip-main" href="#main">Skip to main content</a>
        <div class="home my-4 px-4 container" id="edit-account">
            <div class="row mb-4">
                <div id="main" role="main" class="col-12">
                    <form ref="form" label-position="left" class="userform">
                        <div class="card shadow mx-auto mt-4 max-width-4 bg-light px-lg-5 px-md-0 px-lg-5">
                            <div class="card-body px-lg-5 text-left">
                                <h2 class="mb-4 mt-3">Edit Account</h2>
                                <form-errors :errors="errors" aria-invalid='true'></form-errors>
                                <app-success :success="defaultSuccess" aria-invalid='true'></app-success>
                                <app-error :error="defaultError" aria-invalid='true'></app-error>
                                <user-form v-if="user" :user-form="editForm"></user-form>
                                <b-button class="full-green-btn mt-3" @click="updateUserDetailsRequest()" :disabled="formLock">
                                    <span v-if="!formLock">Update Details <svg-icon v-if="name != 'sestran'" class="arrow-right-find" name="forward"></svg-icon></span>
                                    <b-spinner v-if="formLock" type="grow" label="Spinning" style="width: 24px; height: 24px;" class="app-spinner-white"></b-spinner>
                                </b-button>
                                <b-button class="full-green-btn change-pw-btn mt-3" @click="sendPasswordResetRequest()" :disabled="formLock">
                                    <span >Change Password <svg-icon v-if="name != 'sestran'" class="arrow-right-find-change" name="forward"></svg-icon></span>
                                </b-button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mutationsMapping from '@/store/mutations-mapping'
import {
    mapState,
    mapActions,
    mapMutations,
} from 'vuex'
import moment from 'moment'
import FormErrors from '@/components/FormErrors.vue'
import AppSuccess from '@/components/AppSuccess.vue'
import AppError from '@/components/AppError.vue'
import UserForm from '@/components/UserForm.vue'

const whitelabel = require('../../../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {

    name: 'Edit',
    components: {
        FormErrors,
        AppError,
        AppSuccess,
        UserForm,
    },
    data() {
        return {
            formLock: false,
            editForm: {},
            name: whitelabel.brand,
        }
    },
    computed: {
        ...mapState([
            'errors',
            'defaultError',
            'defaultSuccess',
            'user',
            'auth',
        ]),
    },
    methods: {
        ...mapMutations(mutationsMapping),
        ...mapActions([
            'updateUser',
            'passwordReset',
        ]),
        onFocus(field) {
            this.setError({
                field,
                error: false,
            })
        },
        prepareInput() {
            const editForm = { ...this.editForm }
            editForm.dob = this.formatDate(this.editForm.dob)
            if (editForm.dob) {
                editForm.dob = this.formatDate(this.editForm.dob)
            } else {
                delete editForm.dob
            }
            return editForm
        },
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD')
        },
        formatDateDisplay(value) {
            return moment(String(value)).format('DD-MM-YYYY')
        },
        updateUserDetailsRequest() {
            this.editForm.dob = this.formatDate(this.editForm.dob)
            this.setDefaultError(false)
            this.setDefaultSuccess(false)
            this.updateUser({
                params: this.editForm,
                router: this.$router,
            })
        },
        sendPasswordResetRequest() {
            const element = document.getElementById('edit-account');
            const top = element.offsetTop;
            window.scrollTo(0, top);
            this.passwordReset({ params: { email: this.user.email } })
        },
        prepareEditForm() {
            if (this.user) {
                this.editForm = {
                    title: this.user.title,
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    phone_number: this.user.phone_number,
                    email: this.user.email,
                    dob: this.formatDate(this.user.dob),
                    has_concessionary_pass: this.user.profile.has_concessionary_pass,
                    has_young_scot_card: this.user.profile.has_young_scot_card,
                    has_new_young_scot_card: this.user.profile.has_new_young_scot_card,
                    has_car_access: this.user.profile.has_car_access,
                    railcard: this.user.profile.railcard,
                }
            }
        },
    },
    watch: {
        user() {
            this.prepareEditForm()
        },
    },
    mounted() {
        this.prepareEditForm()
    },
}
</script>
<style lang="scss">

.change-pw-btn{
    background: transparent !important;
    border: 1px solid !important;
}
.arrow-right-find-change path {
    fill: #3D4B55;
}
</style>
